module.exports = __webpack_public_path__ + "img/logoxiao@2x.84bc1d5e.png";